import React from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import classNames from "classnames";
import {
  UseFormRegisterReturn,
  Controller,
  FieldValues,
  Control,
} from "react-hook-form";
import CalendarIcon from "@/shared/icons/CalendarIcon";
import AlertCircleIcon from "@/shared/icons/AlertCircleIcon";
import "./DateInput.scss";
import { FieldSettings, TextObject } from "@/shared/types";

interface DateInputProps {
  registerProps: UseFormRegisterReturn;
  isError?: boolean;
  fieldSettings: FieldSettings;
  id: string;
  fieldControl: Control<FieldValues, any>;
  text: TextObject;
}
function DateComp({
  fieldControl,
  isError,
  fieldSettings,
  id,
  text,
}: DateInputProps) {
  const DatePickerComponent =
    typeof DatePicker === "function" ? DatePicker : (DatePicker as any).default;
  return (
    <div
      className={classNames("general-input-wrapper-view", {
        dateContainer: true,
        ["error"]: isError,
      })}
    >
      <CalendarIcon color="#667085" />
      <Controller
        control={fieldControl}
        name={id}
        render={({ field }) => (
          <DatePickerComponent
            dateFormat="yyyy/MM/dd"
            popperModifiers={[
              {
                name: "flip",
                enabled: false,
              },
            ]}
            showPopperArrow={false}
            onChange={(date) => field.onChange(date)}
            placeholderText={text[fieldSettings?.placeholder?.textId!]}
            selected={field?.value}
            popperPlacement="auto"
            calendarClassName={classNames({
              calenderStyle: true,
            })}
          />
        )}
      />
      <div>{isError && <AlertCircleIcon />}</div>
    </div>
  );
}

export default DateComp;
